/* unplugin-vue-components disabled */import script from "./SalesmanAccountManage.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesmanAccountManage.vue?vue&type=script&setup=true&lang=js"

import "./SalesmanAccountManage.vue?vue&type=style&index=0&id=6a3fdd94&scoped=true&lang=css"

import exportComponent from "/data/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3fdd94"]])

export default __exports__